



























import { Component, Vue, Watch } from "vue-property-decorator";
import messagePraise from "./messageModel/messagePraise.vue";
import messageReply from "./messageModel/messageReply.vue";
import messageNotice from "./messageModel/messageNotice.vue";
import { MessageNum, Readnotice, Readpraise, Readreply } from "@/req/user";
@Component({
  components: {
    messagePraise,
    messageReply,
    messageNotice,
  },
})


export default class Logout extends Vue {
  public visible = false;
  public tabComId: any = "praiseNum";
  public unread = 0;
  public judgeMsg = true;
  public tabCom = "messagePraise";
  public tabComLast = "";
  public poptipcla = "messagepoptip";
  public isLoading = false;

  public mounted() {
    if (this.$fn.cookies.getToken()) {
      this.messNum();
    }
  }
  @Watch("tabComId")
  public handleWatch() {
    if (this.tabComId == "praiseNum") {
      this.tabCom = "messagePraise"
    } else if (this.tabComId == "replyNum") {
      this.tabCom = "messageReply"
    } else if (this.tabComId == "noticeNum") {
      this.tabCom = "messageNotice"
    }
  }
  public async onMessage() {
    if (this.visible) return;
    this.judgeMsg = true;
    this.show();
    this.messNum();
  }
  // 获取未读消息数量
  public async messNum() {
    const obj = {
      token: this.$fn.cookies.getToken(),
    };
    const res = await MessageNum(obj);
    if (res.code == 200) {
      let num = 0;
      Object.keys(res.data.messageNum).forEach((key, index) => {
        num += res.data.messageNum[key];
        if (res.data.messageNum[key] !== 0 && this.judgeMsg) {
          this.tabComId = key;
        }
      })
      this.judgeMsg = false;
      this.$store.state.user.message = num;
      this.unread = this.$store.state.user.message >= 99 ? "99+" : this.$store.state.user.message;
    }
  }

  public showTabCom(val) {
    this.tabComLast = this.tabCom;
    if (val == "praise") {
      this.tabComId = "praiseNum";
      this.tabCom = "messagePraise";
    } else if (val == "reply") {
      this.tabComId = "replyNum";
      this.tabCom = "messageReply";
    } else {
      this.tabComId = "noticeNum";
      this.tabCom = "messageNotice";
    }
    this.touchMessage();
  }
  public async touchMessage() {
    this.show();
    if (!this.$store.state.user.message) return;
    try {
      const obj: any = {
        token: this.$fn.cookies.getToken(),
      };
      let res;
      if (this.tabComLast == "messagePraise") {
        res = await Readpraise(obj);
      } else if (this.tabComLast == "messageReply") {
        res = await Readreply(obj);
      } else if (this.tabComLast == "messageNotice") {
        res = await Readnotice(obj);
      }
      this.messNum();
    } catch (err) {
      this.$Message.error(err);
    }
  }
  public async show() {
    if (this.tabComId === "praiseNum" ) {
      const $messagePraise: any = this.$refs.messagePraise;
      const praise = await $messagePraise.show();
    } else if (this.tabComId === "replyNum" ) {
      const $messageReply: any = this.$refs.messageReply;
      const reply = await $messageReply.show();
    } else {
      const $messageNotice: any = this.$refs.messageNotice;
      const notice = await $messageNotice.show();
    }
  }
  // 跳转前关闭 Poptip
  public close(val) {
    this.visible = val;
  }
}
